// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_5766c0b7","outerContainer":"_7e29d1ab","secondaryToolbar":"_55a0b16c","doorHangerRight":"a5d510cd","toolbarContainer":"_3db3a886","toolbarViewerMiddle":"_513a6b89","progressBar":"bece81ac","back-to-application":"a4850582","content":"f3e54402","btnCancel":"e600908f","btnOverlap":"_9016e1b9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVisit/OverlapModal/styles.styl
// module id = 2274
// module chunks = 39